export const languages = [
    {
        language: "EN",
        subDomain: "en"
    },
    {
        language: "NL",
        subDomain: "nl"
    }
];